import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineXsmallOneLineCompactProps } from './types';
import { bridge, isNil, isNotNil } from '../../../../utils';
import { ViewAllButton } from '../ViewAllButton';
import { useOpenDeeplink } from '../../../../hooks';
import type { IScreensLogging } from '../../../../api/types';

export const HeadlineXsmallOneLineCompact = ({
  header,
}: HeadlineXsmallOneLineCompactProps) => {
  const { openDeeplink } = useOpenDeeplink();

  const handlePressMore = useCallback(() => {
    if (isNil(header) || isNil(header.item.deeplink)) return;
    logClickMore({ logging: header.logging });
    openDeeplink(header.item.deeplink);
  }, [header, openDeeplink]);

  if (isNil(header)) return null;

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      padding={{ top: 16, bottom: 8, left: 16, right: hasDeeplink ? 0 : 16 }}
      alignItems="center"
    >
      <Flex flex={1}>
        <Typography type="subtitle1" color="content_primary" numberOfLines={1}>
          {header.item.title}
        </Typography>
      </Flex>
      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton onPress={handlePressMore} />
        </Flex>
      )}
    </Flex.Row>
  );
};

const logClickMore = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_COMPACT_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
